import { render } from "./CIS-Resource-PagedListing-Items.vue?vue&type=template&id=a96a6bba&scoped=true"
import script from "./CIS-Resource-PagedListing-Items.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-Items.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-Items.vue?vue&type=style&index=0&id=a96a6bba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96a6bba"]])

export default __exports__